import apiConfig from './apiConfig';

const endpointConfig = {
	certificates: `${apiConfig.baseUrl}/certificates`,
	newCertificates: `${apiConfig.baseUrl}/certificates`,
	user: `${apiConfig.baseUrl}/user`,
	certcheck: `${apiConfig.baseUrl}/certcheck`,
	caInfo: `${apiConfig.baseUrl}/ca-info/`,
	certInfo: (certHash: string, serial: string) =>
		`${apiConfig.baseUrl}/cert-info/${encodeURIComponent(certHash)}/${encodeURIComponent(serial)}`,
	docsVerify: `${apiConfig.baseUrl}/docs/verify`,
	// userSupport: `${apiConfig.oldBaseUrl}/user/support`,
	docsUpload: `${apiConfig.baseUrl}/documents/upload-url`,
	newCertificate: `${apiConfig.baseUrl}/onboarding/new-certificate`,
	signPdf: (ulid: string) => `${apiConfig.baseUrl}/documents/${ulid}/sign`,
	docsDownload: `${apiConfig.baseUrl}/documents/download-url`,
	setPin: `${apiConfig.baseUrl}/user/set-pin`,
	downloadSignedDocument: (
		userCognitoId: string,
		documentUlid: string,
		pdfName: string,
	) =>
		`${apiConfig.baseUrl}/documents/download-url?document-path=${encodeURIComponent(`${userCognitoId}/${documentUlid}/signed/${pdfName}`)}`,
	sendSignOTP: (ulid: string) =>
		`${apiConfig.baseUrl}/documents/${ulid}/send-sign-otp`,
	otpVerification: (ulid: string) =>
		`${apiConfig.baseUrl}/onboarding/${ulid}/phone/confirm-otp`,
	dataEnrichment: (ulid: string) =>
		`${apiConfig.baseUrl}/onboarding/${ulid}/data-enrichment`,
	sendOtp: (ulid: string) =>
		`${apiConfig.baseUrl}/onboarding/${ulid}/phone/send-otp`,
	updateCertificate: (serial: string) =>
		`${apiConfig.baseUrl}/certificates/${serial}`,
	downloadCertificate: (serial: string) =>
		`${apiConfig.baseUrl}/certificates/${serial}`,
};

export default endpointConfig;
